// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"43d88e14","769":"73b98490"}[chunkId] + ".chunk.js";
};